import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Accordion } from './Accordion';

/**
 * Collapsible guarantee shown below the offer block: the title is the trigger.
 */
export function GuaranteeSection() {
  return <Accordion id="garantia" className="bg-white" openClassName="bg-cream" header={<span className="flex items-center gap-3" data-id="element-50" data-mp="etpo8kavi8iy">
          <ShieldCheckIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-[#4B7A58]" strokeWidth={1.8} data-id="element-51" data-mp="ercvdc3kudr4" />
          <span className="font-sans text-[15px] font-bold leading-snug text-ink" data-id="element-52" data-mp="jqpt4rvzl58h">
            Nuestra Garantía “Tu vida no tiene que esperar”
          </span>
        </span>} data-id="element-49" data-mp="9tl5enmht1pk">
      <div className="space-y-4 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-53" data-mp="sldwgci04cun">
        <p data-id="element-54" data-mp="xim9jyoalqp1">
          Tenés 7 días para conocer LIBRES DE SER, recorrer su contenido y
          descubrir si realmente es para vos.
        </p>
        <p data-id="element-55" data-mp="17i4p82x66qba">
          Si sentís que no te aporta una nueva mirada, solicitás tu reembolso
          dentro del plazo. Sin explicaciones. Sin justificarte. Te devolvemos
          tu dinero.
        </p>
        <p data-id="element-56" data-mp="20su412tqqnr0">
          Porque creemos que la libertad es para todos. Y si no sentís eso aquí,
          seguís teniendo derecho a encontrarlo en otro lado.
        </p>
        <p className="font-bold text-ink" data-id="element-57" data-mp="1vu0z3ysis52g">
          Garantía 100%: satisfacción o te devolvemos tu dinero.
        </p>
      </div>
    </Accordion>;
}